import { Suspense, useEffect } from 'react'
import { Link, Navigate, Route, Routes, useLocation } from 'react-router-dom'
import { PageLoader } from '../layout/PageLoader'
import { AUTH_PATHS, PUBLIC_PATHS } from './routes'
import { ProtectedRoute } from '../routing/ProtectedRoute'
import { PublicRoute } from '../routing/PublicRoute'
import {
  AdminWaitlist,
  About,
  AccountRecovery,
  Blog,
  BlogPost,
  Careers,
  ForgotAccess,
  HumanAIProject,
  HowWeProtectYourVoice,
  KeepThisVoiceForever,
  Login,
  LoveAccount,
  LoveLanding,
  Paul,
  PhoneVerify,
  Privacy,
  QrAuth,
  Terms,
  Waitlist,
} from './lazyPages'

function ScrollToTop() {
  const { pathname } = useLocation()
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [pathname])
  return null
}

function ReevaRedirect() {
  const location = useLocation()
  const targetPath = location.pathname.replace(/^\/(?:reeva|app)/, '') || '/'
  const target = `https://reeva.returned.com${targetPath}${location.search}${location.hash}`
  useEffect(() => {
    window.location.replace(target)
  }, [target])
  return <PageLoader />
}

function NotFoundPage() {
  return (
    <main style={{ minHeight: '100vh', display: 'grid', placeItems: 'center', padding: '2rem' }}>
      <div style={{ textAlign: 'center' }}>
        <h1 style={{ margin: 0, fontSize: '2rem' }}>Page not found</h1>
        <p style={{ marginTop: '0.75rem' }}>
          The page you requested does not exist on Loveline.
        </p>
        <Link to="/">Go to Loveline</Link>
      </div>
    </main>
  )
}

export function AppRouter() {
  return (
    <Suspense fallback={<PageLoader />}>
      <ScrollToTop />
      <Routes>
        <Route path={AUTH_PATHS.login} element={<PublicRoute><Login /></PublicRoute>} />

        <Route path={PUBLIC_PATHS.home} element={<LoveLanding />} />
        <Route path={PUBLIC_PATHS.pricing} element={<LoveLanding />} />
        <Route path={PUBLIC_PATHS.terms} element={<Terms />} />
        <Route path={PUBLIC_PATHS.privacy} element={<Privacy />} />
        <Route path={PUBLIC_PATHS.about} element={<About />} />
        <Route path={PUBLIC_PATHS.paul} element={<Paul />} />
        <Route path={PUBLIC_PATHS.blog} element={<Blog />} />
        <Route path={PUBLIC_PATHS.blogPost} element={<BlogPost />} />
        <Route path={PUBLIC_PATHS.humanAiProject} element={<HumanAIProject />} />
        <Route path={PUBLIC_PATHS.research} element={<HumanAIProject />} />
        <Route path={PUBLIC_PATHS.careers} element={<Careers />} />
        <Route path={PUBLIC_PATHS.howWeProtect} element={<HowWeProtectYourVoice />} />
        <Route path={PUBLIC_PATHS.keepVoiceForever} element={<KeepThisVoiceForever />} />
        <Route path={PUBLIC_PATHS.waitlist} element={<Waitlist />} />

        <Route path={PUBLIC_PATHS.deprecatedClaim} element={<Navigate to="/" replace />} />

        <Route path={AUTH_PATHS.verify} element={<PublicRoute><PhoneVerify /></PublicRoute>} />
        <Route path={AUTH_PATHS.recover} element={<PublicRoute><AccountRecovery /></PublicRoute>} />
        <Route path={AUTH_PATHS.forgotAccess} element={<PublicRoute><ForgotAccess /></PublicRoute>} />
        <Route path={AUTH_PATHS.qrAuth} element={<QrAuth />} />

        <Route path="/admin" element={<ProtectedRoute><AdminWaitlist /></ProtectedRoute>} />
        <Route path="/love/admin" element={<ProtectedRoute><AdminWaitlist /></ProtectedRoute>} />
        <Route path="/loveline/admin" element={<ProtectedRoute><AdminWaitlist /></ProtectedRoute>} />
        <Route path="/love-account" element={<ProtectedRoute><LoveAccount /></ProtectedRoute>} />
        <Route path="/loveline/account" element={<ProtectedRoute><LoveAccount /></ProtectedRoute>} />
        <Route path="/love/account" element={<ProtectedRoute><LoveAccount /></ProtectedRoute>} />
        <Route path="/loveline" element={<LoveLanding />} />
        <Route path="/loveline/*" element={<LoveLanding />} />
        <Route path="/love" element={<LoveLanding />} />
        <Route path="/love/*" element={<LoveLanding />} />

        <Route path="/reeva/*" element={<ReevaRedirect />} />
        <Route path="/app/*" element={<ReevaRedirect />} />
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </Suspense>
  )
}
